import flatpickr from 'flatpickr/dist/esm/index.js';

import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { default as Chinese } from 'flatpickr/dist/l10n/zh.js';

const locales = {
  uk: Ukrainian,
  cs: Czech,
  ru: Russian,
  de: German,
  fr: French,
  es: Spanish,
  zh: Chinese,
};

// Ініціалізація flatpickr для вибору дати і часу
// з локалізацією в залежності від мови браузера
// (підтримуються: uk, cs, ru, de, fr, es, zh, інші - за замовчуванням англійська)
// Tiny helper to temporarily lock page zoom on iOS while the picker is open
function iosTemporarilyLockZoom(lock) {
  try {
    const isIOS =
      /iP(hone|od|ad)/.test(navigator.platform) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    if (!isIOS) return;

    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;

    const current =
      meta.getAttribute('content') || 'width=device-width, initial-scale=1';
    if (lock) {
      if (!/maximum-scale=1/.test(current)) {
        meta.setAttribute('content', current + ', maximum-scale=1');
      }
    } else {
      meta.setAttribute('content', current.replace(/,\s*maximum-scale=1/g, ''));
    }
  } catch {
    // noop
  }
}

const ONE_HOUR_MS = 60 * 60 * 1000;
const getMinDateTime = () => {
  const min = new Date(Date.now() + ONE_HOUR_MS);
  min.setSeconds(0, 0);
  return min;
};

document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('.input-date-time');
  if (!inputs.length) return; // тихо виходимо, якщо інпутів немає

  const userLang = navigator.language || navigator.userLanguage;
  const langCode = userLang.split('-')[0];
  const selectedLocale = locales[langCode] || 'default';

  inputs.forEach(input => {
    flatpickr(input, {
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      time_24hr: true,
      locale: selectedLocale,
      minDate: getMinDateTime(),
      // Force Flatpickr UI on mobile instead of native pickers
      disableMobile: true,
      onOpen: (_selectedDates, _dateStr, instance) => {
        iosTemporarilyLockZoom(true);
        instance.set('minDate', getMinDateTime());
      },
      onClose: () => iosTemporarilyLockZoom(false),
    });
  });
});
